import { ShieldCheck } from "lucide-react";

/** Fim da aba de "ver como" — encerrada, vencida ou revogada pela pessoa. */
export function VerComoEncerrado() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 p-4">
      <div className="mx-auto w-full max-w-md rounded-2xl border border-zinc-200 bg-white p-6 text-center shadow-sm">
        <ShieldCheck className="mx-auto h-8 w-8 text-amber-500" />
        <h1 className="mt-3 text-lg font-semibold text-zinc-900">Sessão de suporte encerrada</h1>
        <p className="mt-1 text-sm text-zinc-500">
          O acesso em modo leitura terminou (encerrado, vencido ou revogado pela pessoa). Pode fechar esta aba.
        </p>
      </div>
    </div>
  );
}
